import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPreviewPrinter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9.25 10.75H6.75M17.25 13.75V17.25H19.25C20.3546 17.25 21.25 16.3546 21.25 15.25V8.75C21.25 7.64543 20.3546 6.75 19.25 6.75H4.75C3.64543 6.75 2.75 7.64543 2.75 8.75V15.25C2.75 16.3546 3.64543 17.25 4.75 17.25H6.75V13.75H17.25V19.25C17.25 20.3546 16.3546 21.25 15.25 21.25H8.75C7.64543 21.25 6.75 20.3546 6.75 19.25V13.75M8.75 2.75H15.25C16.3546 2.75 17.25 3.64543 17.25 4.75V6.75H6.75V4.75C6.75 3.64543 7.64543 2.75 8.75 2.75Z"
    />
  </svg>
);
export default SvgPreviewPrinter;
